/**
 * PATH: packages/job-hub/src/jobs/qa/qaStatusOptions.ts
 * FILE_ID: JOBHUB-QA-STATUS-OPTIONS-001
 * PURPOSE: Shared Pass / Fail / Further Action / N/A labels for ITP run UI.
 */
import type { QaItemStatus } from './qaTypes'

export const QA_STATUS_OPTIONS: { status: QaItemStatus; label: string }[] = [
  { status: 'done', label: 'Pass' },
  { status: 'failed', label: 'Fail' },
  { status: 'further_action', label: 'F A' },
  { status: 'not_applicable', label: 'N/A' },
]

export function matchesRunFilter(status: string, filter: QaItemStatus | null): boolean {
  if (!filter) return true
  return filter === 'done' ? status === 'done' || status === 'pass' : status === filter
}

export function runFilterCounts(items: readonly { status: string }[]): Partial<Record<QaItemStatus, number>> {
  const n = (s: string) => items.filter((item) => item.status === s).length
  return {
    done: n('done') + n('pass'),
    failed: n('failed'),
    further_action: n('further_action'),
    not_applicable: n('not_applicable'),
  }
}
